import React from "react";
import "./App.css";

export default function Separator({ tight = false }) {
  return <div className={`sep ${tight ? "sep--tight" : ""}`} />;
}
